module.exports = __webpack_public_path__ + "static/media/linkedin-logo.bbf7ff60.svg";